import * as d3 from 'd3'

export default {
  methods: {

    draw_Detail(sys, data) {

      let status = this.canvasForms
      .append('g')
      .attr('transform', `translate(780, 40)`)

      status
      .append('text')
      .attr('id', `SYS_TITLE1`)
      .attr('transform', `translate(0, 15)`).attr('font-size', 9).attr('fill', '#757575')
      .text(sys=='SYS' ? 'System No.' : 'Sub-System No.')

      status
      .append('text')
      .attr('id', `SYS_NO`)
      .attr('transform', `translate(0, 30)`).attr('font-size', 14)
      .attr('fill', sys=='SYS' ? '#EC407A' : '#333')
      .text(sys=='SYS' ? data.SYS : data.SUBSYS)

      status
      .append('image')
      .attr('id', `INFO`)
      .attr('xlink:href', sys=='SYS' ? this.HOST + '/icon/info_Red.svg' : this.HOST + '/icon/info_Blue.svg')
      .attr('x', this.getNode(`#SYS_NO`) + 5).attr('y', 18).attr('width', 14)

      status
      .append('text')
      .attr('id', `SYS_TITLE2`)
      .attr('transform', `translate(0, 45)`).attr('font-size', 9).attr('fill', '#757575')
      .text(sys=='SYS' ? 'System Description' : 'Sub-System Description')

      status
      .append('text')
      .attr('id', `SYS_DESC`)
      .attr('transform', `translate(0, 60)`).attr('font-size', 14)
      .attr('fill', sys=='SYS' ? '#EC407A' : '#333')
      .text(sys=='SYS' ? data.SYS_DESC : data.SUBSYS_DESC)

      if(sys == 'SUBSYS') this.draw_MCC(status, data)

      this.group.forEach(d=> {

        let items = status
        .append('g')
        .attr('id', `${d.id}`)
        .attr('transform', `translate(${d.x}, 83)`)
        .attr('opacity', sys == 'SUBSYS' && d.id == 'CERT' ? 0 : 1)

        items
        .append('rect')
        .attr('x', 0).attr('y', 0).attr('rx', 2)
        .attr('width', d.id == 'CERT' ? 170 : 270)
        .attr('height', (d.items.length * 20) + 20)
        .attr('fill', d.color).attr('stroke', '#bcbcbc').attr('stroke-wisth', .5).attr('opacity', d.opacity)

        items
        .append('text')
        .attr('x', 0).attr('y', -3).attr('font-size', 11).attr('fill', '#333')
        .text(d.name)


        // Header
        this.columns.filter(f=> f.name && f.code != 'PRO').forEach(col=> {
          items
          .append('text')
          .attr('x', col.tx).attr('y', 15)
          .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', col.align)
          .text(col.name)
        })

        // Status
        let y_ = 30
        d.items.forEach(item=> {
          
          items
          .append('text')
          .attr('x', 47).attr('y', y_)
          .attr('font-size', 10).attr('fill', '#000').attr('text-anchor', 'end')
          .text(this.status.find(f=> f.id == item).name)

          this.columns.filter(f=> f.name).forEach(col=> {
            
            if(col.code != 'PRO') {
              items
              .append('text')
              .attr('id', `${item}_${col.code}`)
              .attr('x', col.tx).attr('y', y_)
              .attr('fill', data[`${item}_${col.code}`] == 0 ? '#757575' : col.tColor)
              .attr('font-size', 11).attr('text-anchor', 'end')
              .text(data[`${item}_${col.code}`])
              .call(this.event_Link, item, data, col)
            }

            if(d.id != 'CERT' && col.code == 'PRO') {
              items
              .append('rect')
              .attr('x', col.sx + 5).attr('y', y_-9)
              .attr('width', 100)
              .attr('height', 10)
              .attr('fill', '#E0E0DF').attr('opacity', .7)

              items
              .append('rect')
              .attr('id', `${item}_${col.code}_BAR`)
              .attr('x', col.sx + 5).attr('y', y_-9)
              .attr('width', data[`${item}_${col.code}`])
              .attr('height', 10)
              .attr('fill', this.status.find(f=> f.id == item).bColor).attr('opacity', .7)

              let prog = data[`${item}_${col.code}`]
              items
              .append('text')
              .attr('id', `${item}_${col.code}`)
              .attr('x', prog < 75 ? col.sx + 6 + prog : col.sx + 4 + prog)
              .attr('y', y_-.5)
              .attr('font-size', 10).attr('fill', col.tColor)
              .attr('text-anchor', prog < 75 ? 'start' : 'end')
              .text(prog + '%')
            }
          })

          y_ += 20
        })

      })

    },



    draw_MCC(selection, data) {

      let mcc = selection
      .append('g')
      .attr('id', `SCH_MCC`)
      .attr('transform', `translate(-10, 60)`)

      this.mcc.filter(f=>f.id != 'F').forEach((d,i)=> {

        mcc
        .append('text')
        .attr('x', 20).attr('y', (i*35) + 24 + 10*0.35)
        .attr('font-size', 10).attr('fill', '#757575')
        .text(d.name)

        mcc
        .append('rect')
        .attr('x', 20).attr('y', (i*35) + 30)
        .attr('width', 80).attr('height', 18)
        .attr('fill', 'none').attr('stroke', '#E0E0DF').attr('stroke-wisth', .5)

        mcc
        .append('text')
        .attr('id', `SCH_${d.id}`)
        .attr('x', 60).attr('y', (i*35) + 39 + 11*0.35)
        .attr('font-size', 11).attr('fill', '#333')
        .attr('text-anchor', 'middle')
        .text(data[`MCC_${d.id}`])
      })

    }
  }
}